module.exports = __webpack_public_path__ + "img/des_muyu_2.d7fdd1c0.jpg";